import commonApi from './CommonApi.js';

export default {
	register: async (viewModel) => {
		return await commonApi().post('/v1/registration?language=' + window.currentLanguageEnum, viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
	invitation: async (viewModel) => {
		return await commonApi().post('/v1/registration/invitation?language=' + window.currentLanguageEnum, viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	}
}